import React, { useEffect, useState } from "react";
import { Table, Checkbox, Tabs } from "antd";
import { setSideTab } from "../../../toolkit/slices/inventories/inventorySlice";
import { useDispatch } from "react-redux";
import { modules } from "../SideBarContainer";
import accessCheckPromise from "../../../../utils/accessCheck";
import AuthorizationError from "../AuthorizationError";
import "./PermissionsContainer.css";
import { logoutUser } from "../../../toolkit/slices/users/userSlice";
let apiBaseUrl = process.env.REACT_APP_API_BASE_URL;

const PermissionsContainer = () => {
  const [activeTab, setActiveTab] = useState("1");
  const [access, setAccess] = useState(false);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(setSideTab(window.location.pathname));
    accessCheckPromise()
      .then((res) => setAccess(res))
      .catch((error) => {
        dispatch(logoutUser());
      });
  }, []);
  let tabs = [
    { key: "1", label: "Module Access" },
    { key: "2", label: "Feature Access" },
  ];
  const tabChange = (key) => {
    setActiveTab(key);
  };
  const renderTabContent = () => {
    switch (activeTab) {
      case "1":
        return <MemoizedModuleAccess />;

      case "2":
        return <MemoizedFeatureAccess />;

      default:
        return null;
    }
  };
  if (!access) {
    return <AuthorizationError />;
  }
  return (
    <div
      className="parent-padding-container"
      style={{
        backgroundColor: "white",
        borderRadius: "12px",
        padding: "0px 20px",
      }}
    >
      <div
        style={{
          // backgroundColor: "white",
          padding: "0px 20px",
          borderRadius: "12px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: "1rem",
        }}
      >
        <Tabs
          defaultActiveKey="1"
          activeKey={activeTab}
          onChange={tabChange}
          items={tabs}
        />
      </div>
      {renderTabContent()}
    </div>
  );
};

export default PermissionsContainer;

const ModuleAccess = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [columns, setColumns] = useState([]);

  useEffect(() => {
    fetchUsersForYellowSpot();
    fillInModules();
  }, []);

  async function fetchUsersForYellowSpot() {
    try {
      let response = await fetch(
        `${apiBaseUrl}/inventoryManagement/getUsersWithModules`,
        {
          method: "GET",
          credentials: "include",
        },
      );
      let responseJson = await response.json();
      // Set the initial state of users based on the response
      setUsers(responseJson.data);
    } catch (error) {
      console.error(`Error fetching users: ${error.message}`);
    } finally {
      setLoading(false);
    }
  }

  const handleCheckboxChange = async (userId, module) => {
    let us;
    setUsers((users) => {
      const updatedUsers = users.map((user) => {
        if (user._id === userId) {
          const updatedModules = {
            ...user.modules,
            [module]: !user.modules[module] ? true : undefined, // Toggle to true only
          };

          // Filter out modules that are undefined (i.e., were toggled to false)
          const filteredModules = Object.fromEntries(
            Object.entries(updatedModules).filter(
              ([key, value]) => value === true,
            ),
          );

          return { ...user, modules: filteredModules };
        }
        return user;
      });

      us = updatedUsers;
      return updatedUsers;
    });

    // Send updated modules to backend

    if (us) {
      await fetch(`${apiBaseUrl}/inventoryManagement/modifyPermissions`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ users: us }),
        credentials: "include",
      });
    }
  };
function fillInModules() {
  const headerMultiLine = {
    Dashboard: (
      <div style={{ textAlign: "center", lineHeight: 1.1, whiteSpace: "normal", overflowWrap: "anywhere" }}>
        <div>Dashboard</div>
        
      </div>
    ),
    Reports: (
      <div style={{ textAlign: "center", lineHeight: 1.1, whiteSpace: "normal", overflowWrap: "anywhere" }}>
        <div>Reports</div>
      </div>
    ),
    "Proposal Approvals": (
      <div style={{ textAlign: "center", lineHeight: 1.1, whiteSpace: "normal", overflowWrap: "anywhere" }}>
        <div>Proposal</div><div>Approvals</div>
      </div>
    ),
    "Premium Blocks": (
      <div style={{ textAlign: "center", lineHeight: 1.1, whiteSpace: "normal", overflowWrap: "anywhere" }}>
        <div>Premium</div><div>Blocks</div>
      </div>
    ),
    "Inventory Master": (
      <div style={{ textAlign: "center", lineHeight: 1.1, whiteSpace: "normal", overflowWrap: "anywhere" }}>
        <div>Inventory</div><div>Master</div>
      </div>
    ),
    "Purchase Order": (
      <div style={{ textAlign: "center", lineHeight: 1.1, whiteSpace: "normal", overflowWrap: "anywhere" }}>
        <div>Purchase</div><div>Order</div>
      </div>
    ),
    "Sales Order": (
      <div style={{ textAlign: "center", lineHeight: 1.1, whiteSpace: "normal", overflowWrap: "anywhere" }}>
        <div>Sales</div><div>Order</div>
      </div>
    ),
    "AI Reporting & Insights": (
      <div style={{ textAlign: "center", lineHeight: 1.1, whiteSpace: "normal", overflowWrap: "anywhere" }}>
        <div>AI Reporting</div><div>&amp; Insights</div>
      </div>
    ),
    "Asset Management": (
      <div style={{ textAlign: "center", lineHeight: 1.1, whiteSpace: "normal", overflowWrap: "anywhere" }}>
        <div>Asset</div><div>Management</div>
      </div>
    ),
    "Client Management": (
      <div style={{ textAlign: "center", lineHeight: 1.1, whiteSpace: "normal", overflowWrap: "anywhere" }}>
        <div>Client</div><div>Management</div>
      </div>
    ),
    "Salesman Register": (
      <div style={{ textAlign: "center", lineHeight: 1.1, whiteSpace: "normal", overflowWrap: "anywhere" }}>
        <div>Salesman</div><div>Register</div>
      </div>
    ),
    "Mounting Proof": (
      <div style={{ textAlign: "center", lineHeight: 1.1, whiteSpace: "normal", overflowWrap: "anywhere" }}>
        <div>Mounting</div><div>Proof</div>
      </div>
    ),
  };

  const data = modules.map((ele) => {
    const title = headerMultiLine[ele] ? headerMultiLine[ele] : (
      <div style={{ textAlign: "center", whiteSpace: "normal", overflowWrap: "anywhere" }}>
        {ele}
      </div>
    );

    return {
      title,
      key: ele,
      width: 150,        
      align: "center",
      ellipsis: false,
      onHeaderCell: () => ({
        style: {
          whiteSpace: "normal",
          overflowWrap: "anywhere",
          wordBreak: "break-word",
        },
      }),
      render: (_, record) => (
        <Checkbox
          checked={record.modules[ele] || false}
          onClick={(e) => e.stopPropagation()}
          onChange={() => handleCheckboxChange(record._id, ele)}
        />
      ),
    };
  });

  setColumns([
    { title: "User", dataIndex: "name", key: "name", width: 200, fixed: "left" }, // ✅ keep user visible
    ...data,
  ]);
}

  const components = {
    header: {
      cell: (props) => (
        <th
          {...props}
          style={{
            ...props.style,
            backgroundColor: "#daeffe",
          }}
        />
      ),
    },
  };

  return (
    <div id="Permissionstable">
      <Table
        sticky
        scroll={{ x: "max-content", y: 500 }}
        dataSource={users}
        columns={columns}
        rowKey="_id" // Use _id as the unique key
        pagination={false} // Optional: Disable pagination if not needed
        components={components}
      />
    </div>
  );
};
const MemoizedModuleAccess = React.memo(ModuleAccess);

const FeatureAccess = () => {


  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [columns, setColumns] = useState([]);

  const features = ["Maintenance Cost"]; // Static feature array (expandable)
    const components = {
    header: {
      cell: (props) => (
        <th
          {...props}
          style={{
            ...props.style,
            backgroundColor: "#daeffe",
          }}
        />
      ),
    },
  };

  useEffect(() => {
    fetchUsersForYellowSpot();
    fillInFeatures();
  }, []);

  async function fetchUsersForYellowSpot() {
    try {
      let response = await fetch(
        `${apiBaseUrl}/inventoryManagement/getUsersWithModules`,
        {
          method: "GET",
          credentials: "include",
        },
      );
      let responseJson = await response.json();
      setUsers(responseJson.data);
    } catch (error) {
      console.error(`Error fetching users: ${error.message}`);
    } finally {
      setLoading(false);
    }
  }

  const handleFeatureCheckboxChange = async (userId, feature) => {
    let updatedUsers;
    setUsers((users) => {
      const newUsers = users.map((user) => {
        if (user._id === userId) {
          const updatedFeatures = {
            ...user.modules,
            [feature]: !user.modules?.[feature] ? true : undefined,
          };
          const filteredFeatures = Object.fromEntries(
            Object.entries(updatedFeatures).filter(
              ([key, value]) => value === true,
            ),
          );
          return { ...user, modules: filteredFeatures };
        }
        return user;
      });

      updatedUsers = newUsers;
      return newUsers;
    });

    if (updatedUsers) {
      await fetch(`${apiBaseUrl}/inventoryManagement/modifyPermissions`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ users: updatedUsers }),
        credentials: "include",
      });
    }
  };

  function fillInFeatures() {
    let data = features.map((feature) => ({
      title: feature,
      key: feature,
      render: (_, record) => (
        <Checkbox
          checked={record.modules?.[feature] || false}
          onClick={(e) => e.stopPropagation()}
          onChange={() => handleFeatureCheckboxChange(record._id, feature)}
        />
      ),
    }));

    setColumns([{ title: "User", dataIndex: "name", key: "name" }, ...data]);
  }

  return (
    <div id="Permissionstable">
      <Table
      sticky
        scroll={{ y: 500 }}
        dataSource={users}
        columns={columns}
        rowKey="_id"
        pagination={false}
        components={components}
      />
    </div>
  );
};

const MemoizedFeatureAccess = React.memo(FeatureAccess);
